export default "__VITE_ASSET__ztDNFPE0__"